export default __webpack_public_path__ + "static/media/digital-empire-big-12@2x.854ca284.png";